

























































import {
  defineComponent,
} from '@vue/composition-api'

export default defineComponent({

  props: {
    title: { type: String, default: '' },
    hideToolBar: { type: Boolean, default: false },
    toolBarColor: { type: String, default: 'grey lighten-3' },
    loading: Boolean,
    busy: Boolean,
    elevation: { type: Number, default: 2 },
  },

  setup(props) {
    return { props }
  },
})

